import React, { useState, useEffect } from "react";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import Modal from "../../components/Modal/Modal";
import { toast, ToastContainer } from "react-toastify";
import { changeAdminStatus, getAllUsers } from "../../services/userService";
import UserTable from "../../components/Table/UserTable";
import EditModal from "../../components/Modal/EditModal";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import BulkUpdateAIModal from "../../components/Modal/BulkUpdateAIModal";
import { useLocation } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import UserListTransfer from "../../components/ChooseAiList/UserListTransfer ";
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";

const UserScreen = () => {
  const [color, setColor] = useColor("#561ecb");
  const [isOpen, setIsOpen] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [userData, setUserData] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isBulkUpdateOpen, setIsBulkUpdateOpen] = useState(false);
  const [functionData, setFunctionData] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialSearchTerm = queryParams.get("searchValue") || "";
  const initialPageNumber = queryParams.get("pageValue") || null;
  const initialRowPerPage = queryParams.get("rowsPerPage") || null;
  const initialSortBy = queryParams.get("sortBy") || "Name";
  const initialSortorder = queryParams.get("sortOrder") || "asc";

  const [rowsPerPage, setRowsPerPage] = useState(initialRowPerPage || 10);
  const [pageNumber, setPageNumber] = useState(initialPageNumber || 1);
  const [totalRows, setTotalRows] = useState(0);

  const [searchKeyword, setSearchKeyword] = useState(initialSearchTerm);
  const [sortBy, setSortBy] = useState(initialSortBy);
  const [sortOrder, setSortOrder] = useState(initialSortorder);

  const manageSortBy = (a, b) => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    searchParams.set("sortBy", a);
    searchParams.set("sortOrder", b);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);

    setSortBy(a);
    setSortOrder(b);
  };

  const handleSearchKeyword = (searchInput) => {
    setSearchKeyword(searchInput);

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set("searchValue", searchInput);
    searchParams.set("pageValue", 1);
    searchParams.set("rowsPerPage", 10);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);

    setRowsPerPage(10);
    setPageNumber(1);
  };

  const PageChange = (val) => {
    setPageNumber(val);
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    searchParams.set("pageValue", val);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);
  };

  const updateAdminStatus = async (request) => {
    setLoading(true);
    try {
      const res = await changeAdminStatus(request);
      if (res?.status === "success") {
        toast("Changed admin status sucessfully");
        setLoading(false);
      } else throw new Error("Failed To Update User Status");
    } catch (e) {
      setLoading(false);
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  // useEffect(() => {
  //   if (searchKeyword !== "")
  //     setUsers(
  //       allUsers.filter(
  //         (u) =>
  //           u.Name.includes(searchKeyword) || u.email.includes(searchKeyword)
  //       )
  //     );
  //   else setUsers(allUsers);
  //   // eslint-disable-next-line
  // }, [searchKeyword]);

  useEffect(() => {
    const getUsers = async () => {
      setLoading(true);

      const queryParams = new URLSearchParams({
        rowsPerPage: rowsPerPage,
        pageNumber: pageNumber,
        searchKeyWord: searchKeyword,
        sortBy: sortBy,
        sortOrder: sortOrder,
      });

      try {
        const res = await getAllUsers(queryParams);
        if (res?.status === "success") {
          setUsers(res.results);
          setAllUsers(res.results);
          setTotalRows(res?.totalRows ? res?.totalRows : 0);
          setLoading(false);
        } else throw new Error("Failed To Fetch All Users");
      } catch (e) {
        setLoading(false);
        setUsers([]);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    getUsers();
    // eslint-disable-next-line
  }, [rowsPerPage, pageNumber, searchKeyword, sortOrder, sortBy]);

  return (
    <>
      <ToastContainer />
      {isOpen && <Modal setIsOpen={setIsOpen} setLoadingUsers={setLoading} />}
      {isEditOpen && (
        <EditModal
          setUsers={setUsers}
          setIsOpen={setIsEditOpen}
          setLoadingUsers={setLoading}
          data={userData}
        />
      )}
      {isConfirmOpen && (
        <ConfirmModal
          setAllUsers={setUsers}
          setIsOpen={setIsConfirmOpen}
          setLoading={setLoading}
          functionData={functionData}
          setFunctionData={setFunctionData}
        />
      )}
      {isBulkUpdateOpen && (
        <BulkUpdateAIModal
          setIsOpen={setIsBulkUpdateOpen}
          setLoadingUsers={setLoading}
        />
      )}
      <NavBar />
      <div style={{ display: "grid", gridTemplateColumns: "200px 1fr" }}>
        <SideBar />
        <div
          style={{
            flexGrow: "1",
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            background: "#F8F8F8",
            overflow: "hidden",
          }}
        >
          {loading ? (
            <div id="svg-container">
              <RotatingLines
                visible={true}
                height="96"
                width="96"
                color="red"
                strokeColor="grey"
                strokeWidth="4"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <>
              <div style={{ padding: "20px 50px", borderRadius: "10px" }}>
                <UserTable
                  totalRows={totalRows}
                  pageNumber={pageNumber}
                  setRowsPerPage={(data) => {
                    setRowsPerPage(data);
                    const url = new URL(window.location.href);
                    const searchParams = new URLSearchParams(url.search);

                    searchParams.set("rowsPerPage", data);
                    url.search = searchParams.toString();
                    window.history.pushState({ path: url.href }, "", url.href);
                  }}
                  manageSortBy={manageSortBy}
                  rowsPerPage={rowsPerPage}
                  setPageNumber={PageChange}
                  data={users}
                  searchKeyWord={searchKeyword}
                  setSearchKeyWord={setSearchKeyword}
                  pending={loading}
                  updateAdminStatus={updateAdminStatus}
                  sortOrderPrev={sortOrder}
                  toggleOpenEdit={() => {
                    setIsEditOpen(!isEditOpen);
                  }}
                  toggleOpen={() => {
                    setIsOpen(!isOpen);
                  }}
                  toggleBulkUpdateOpen={() => {
                    setIsBulkUpdateOpen(!isBulkUpdateOpen);
                  }}
                  setUserData={setUserData}
                  setIsConfirmOpen={setIsConfirmOpen}
                  setFunctionData={setFunctionData}
                  handleSearchKeyword={handleSearchKeyword}
                />
              </div>
            </>
          )}

          {/* <UserListTransfer />

          <ColorPicker color={color} onChange={setColor} /> */}
        </div>
      </div>
    </>
  );
};

export default UserScreen;
